import { specials } from "@/mocks/data";

export default function Special() {
  return (
    <section id="deep" className="relative w-full bg-primary-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">In Depth</p>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">深度观察专题</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            不止于搬运素材，我们也会把热点放下慢镜头，聊一聊现象背后的情绪、逻辑与传播路径。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-8">
          {specials.map((sp, i) => {
            const reverse = i % 2 === 1;
            const imageOrder = reverse ? "lg:order-2" : "lg:order-1";
            const textOrder = reverse ? "lg:order-1" : "lg:order-2";
            return (
              <article
                key={sp.key}
                className="group grid grid-cols-1 items-stretch gap-0 overflow-hidden rounded-lg border border-primary-100 bg-background-50 lg:grid-cols-2"
              >
                <div className={`relative w-full overflow-hidden bg-background-200 ${imageOrder}`}>
                  <div className="aspect-[16/10] w-full lg:h-full lg:min-h-[360px]">
                    <img
                      src={sp.image}
                      alt={sp.title}
                      className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <span className="absolute left-4 top-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                    {sp.category}
                  </span>
                </div>

                <div className={`flex flex-col justify-center gap-4 p-5 md:p-8 ${textOrder}`}>
                  <h3 className="font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                    {sp.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{sp.summary}</p>
                  <ul className="flex flex-col gap-2.5 border-l-2 border-accent-400 pl-4">
                    {sp.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-checkbox-circle-line mt-0.5 text-primary-500" />
                        {p}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-1 flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-4 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line text-foreground-400" />
                      {sp.date}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-eye-line text-foreground-400" />
                      {sp.reads}
                    </span>
                    <a href="#faq" className="inline-flex items-center gap-1 whitespace-nowrap font-semibold text-primary-700 transition-colors hover:text-primary-600">
                      展开讨论
                      <i className="ri-arrow-right-line" />
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}